import { render, staticRenderFns } from "./NoVisitClients.vue?vue&type=template&id=a0878cc0&"
import script from "./NoVisitClients.vue?vue&type=script&lang=js&"
export * from "./NoVisitClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports